export default "__VITE_ASSET__C_e5bzh7__"